import React, { createContext, useContext, useState, useCallback, useMemo } from 'react';
import ar from './locales/ar';
import he from './locales/he';

const locales = { ar, he };

const STORAGE_KEY = 'anabatal_lang';

function getInitialLang() {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved && locales[saved]) return saved;
  } catch {}
  return 'ar';
}

const LangContext = createContext();

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(getInitialLang);

  const setLang = useCallback((l) => {
    setLangState(l);
    try { localStorage.setItem(STORAGE_KEY, l); } catch {}
  }, []);

  const t = useMemo(() => locales[lang] || ar, [lang]);

  const value = useMemo(() => ({ lang, setLang, t }), [lang, setLang, t]);

  return React.createElement(LangContext.Provider, { value }, children);
}

export function useT() {
  const ctx = useContext(LangContext);
  if (!ctx) return ar;
  return ctx.t;
}

export function useLang() {
  const ctx = useContext(LangContext);
  if (!ctx) return { lang: 'ar', setLang: () => {} };
  return { lang: ctx.lang, setLang: ctx.setLang };
}

export function localField(obj, field, lang) {
  if (lang === 'he') {
    const heKey = field.replace(/Ar$/, 'He');
    if (obj[heKey]) return obj[heKey];
  }
  return obj[field] || '';
}

export function useLocalField() {
  const { lang } = useLang();
  return useCallback((obj, field) => localField(obj, field, lang), [lang]);
}

export default ar;
